<template>
  <div class="footer">
    <div class="w footer-main">
      <div class="footer-left">
        <img src="/static/images/logo2.png" alt="" class="footer-logo" />
        <div class="">
          <img src="/static/images/weixin.png" alt="" class="footer-weixin" />
          官方微信
        </div>
        <div class="">
          <img src="/static/images/weibo.png" alt="" class="footer-weixin" />
          <a href="https://weibo.com/gujiajiaju" target=_blank style="color: inherit">
            官方微博
          </a>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-item">
          <div class="footer-item-title">关于顾家</div>
          <a href="https://gw.kukahome.com/" target=_blank class="footer-item-text">官网首页</a>
          <a href="https://gw.kukahome.com/home/aboutUs?id=3" target=_blank class="footer-item-text">品牌历程</a>
          <a href="https://gw.kukahome.com/home/aboutUs?id=2" target=_blank class="footer-item-text">企业文化</a>
          <a href="https://gw.kukahome.com/home/aboutUs?id=4" target=_blank class="footer-item-text">顾家荣耀</a>
          <!--<a href="http://www.kuandi-home.com/" target=_blank class="footer-item-text">宽邸-顾家旗下美式品牌</a>-->
        </div>
        <div class="footer-item">
          <div class="footer-item-title">产品</div>
          <template v-for="item in cateList">
            <template v-for="(childItem) in item.children" >
              <div class="footer-item-text" :key="childItem.category_id" v-if="childItem.category_id == 148" @click="goodsList(item, childItem)">客餐厅系列</div>
              <div class="footer-item-text" :key="childItem.category_id" v-if="childItem.category_id == 46" @click="goodsList(item, childItem)">卧室系列</div>
              <div class="footer-item-text" :key="childItem.category_id" v-if="childItem.category_id == 136" @click="goodsList(item, childItem)">全屋定制</div>
            </template>
          </template>
          <!-- <div href="https://baidu.com" target=_blank class="footer-item-text">客餐厅系列</div>
          <div href="https://baidu.com" target=_blank class="footer-item-text">卧室系列</div>
          <div href="https://baidu.com" target=_blank class="footer-item-text">全屋定制</div> -->
        </div>
        <div class="footer-item">
          <div class="footer-item-title">服务</div>
          <a href="https://gw.kukahome.com/home/service?id=1" target=_blank class="footer-item-text">服务政策</a>
          <a href="https://gw.kukahome.com/home/service?id=1" target=_blank class="footer-item-text">服务流程</a>
          <a href="https://gw.kukahome.com/home/service?id=1" target=_blank class="footer-item-text">服务规范</a>
          <!--<a href="https://gw.kukahome.com/home/appointmen" target=_blank class="footer-item-text">预约设计</a>-->
        </div>
        <div class="footer-item">
          <div class="footer-item-title">合作</div>
          <a href="https://gw.kukahome.com/home/cooperation?id=3" target=_blank class="footer-item-text">招标公告</a>
          <a href="https://gw.kukahome.com/home/cooperation?id=1" target=_blank class="footer-item-text">工程合作</a>
          <a href="https://gw.kukahome.com/join/index.html" target=_blank class="footer-item-text">商家入住</a>
        </div>
        <div class="footer-item footer-item-border">
          <div class="footer-item-title">联系我们</div>
          <a href="" target=_blank class="footer-item-text">客服热线</a>
          <div class="footer-item-tel">4006816816</div>
          <div class="footer-item-time">（8:30~20:00)</div>
        </div>
        <div class="footer-item-right">
          <div class="footer-code">
            <img
              src="/static/images/weixin.jpeg"
              alt=""
              class="footer-code-img"
            />
            <div class="footer-code-text">官方微信服务号</div>
          </div>
          <div class="footer-code">
            <img
              src="/static/images/xcx.jpeg"
              alt=""
              class="footer-code-img"
            />
            <div class="footer-code-text">官方小程序</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ipRecord">
     Copyright © <a href="https://beian.miit.gov.cn/" target=_blank class="footer-item-text">浙ICP备11025180号-1</a>
    </div>
  </div>
</template>
<script>
import YButton from "/components/YButton";
import { getParamByTempName } from "/api/goods";
import { mapMutations, mapState } from "vuex";
import { getCateList } from "/api";
export default {
  data() {
    return {
      info: {},
      renderable: true,
      cateList: null
    };
  },
  mounted() {
    this._getParamByTemplate();
    this._getCateList()
  },
  methods: {
    ...mapMutations([
      "LOG_OUT",
      "RECORD_USERINFO",
      "UPDATE_BREADCRUMB",
      "UPDATE_CARTCOUNT"
    ]),
    _getCateList() {
      getCateList().then(({ data }) => {
        const list = data.filter(item => item.is_show === 1)
        this.cateList = list;
      });
    },
    goodsList(parentItem, item){
      this.UPDATE_BREADCRUMB([parentItem, item]);
      console.log('this.$router',this.$router)
      this.$router.push({ path: "goods" });
      document.documentElement.scrollTop = 0
    },
    _getParamByTemplate() {
      this.renderable = false;
      const params = {
        template_name: "pc",
        version: "v1.0.1",
        page_name: "footer",
      };
      getParamByTempName(params)
        .then(({ data }) => {
          this.info = data.config[0].data[0];
          this.$nextTick((_) => (this.renderable = true));
        })
        .catch(() => {});
    },

    openTo(url) {
      window.open(url);
    },
  },
  components: {
    YButton,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.footer {
  background: #1b1b1b;
  width: 100%;
  height: 320px;
  &-main {
    padding-top: 26px;
    padding-bottom: 29px;
    color: #aaa;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    .footer-left {
      .footer-logo {
        width: 94px;
        height: 94px;
        margin-bottom: 27px;
      }
      div {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 6px;
        cursor: default;
        .footer-weixin {
          width: 24px;
          height: auto;
          margin-right: 12px;
        }
      }
    }
    .footer-right {
      display: flex;
      justify-content: space-between;
      max-width: 85%;
      .footer-item {
        padding-right: 20px;
        min-width: 115px;
        &-title {
          padding-bottom: 14px;
          font-size: 18px;
          color: #ccc;
          line-height: 24px;
        }
        &-text {
          line-height: 24px;
          color: inherit;
          display: block;
          cursor: pointer;
        }
        &-tel {
          padding-top: 5px;
          font-size: 18px;
        }
        &-time {
          font-size: 14px;
          color: #aaa;
        }
      }
      .footer-item-border {
        padding-right: 60px;
        border-right: 1px solid #333;
      }
      .footer-item-right {
        padding-left: 48px;
        display: flex;
        text-align: center;
        .footer-code:first-child {
          margin-right: 29px;
        }
        .footer-code-img {
          width: 86px;
          height: 86px;
        }
      }
    }
  }
  .ipRecord{
    text-align: center;
  }

  .ipRecord .footer-item-text{
    color: #409EFF;
  }
}
</style>



// WEBPACK FOOTER //
// footer.vue?0dbd908c